{
  "pageTitle": "Правила и политики",
  "pageIntro": "Ниже — черновики для платформы VBB PLAY. До подтверждения владельцем названия компании, лицензии и применимого права документы не считаются готовыми к публикации.",
  "draftBadge": "ЧЕРНОВИК — ожидает утверждения",
  "backToList": "Ко всем правилам",
  "updatedLabel": "Версия",
  "version": "0.2-draft",
  "footerNote": "Это не утверждённая юридическая версия. Публикация на живом сайте — только после отдельного разрешения.",
  "navTitle": "Правила",
  "categories": {
    "terms": {
      "title": "Правила использования",
      "summary": "Создание аккаунта, использование платформы и основные обязанности.",
      "sections": [
        {
          "heading": "1. Общие положения",
          "body": "VBB PLAY — платформа онлайн-игр и связанных услуг. Регистрация или использование означает принятие этих правил. Официальное название компании, страна регистрации и лицензия будут добавлены после подтверждения владельцем."
        },
        {
          "heading": "2. Аккаунт",
          "body": "У пользователя может быть только один личный аккаунт. Вы отвечаете за сохранность данных входа. Подозрительные или общие аккаунты могут быть ограничены."
        },
        {
          "heading": "3. Возраст и допустимость",
          "body": "Сервис только для лиц достигших законного возраста. Может потребоваться проверка. При несоответствии аккаунт может быть закрыт."
        },
        {
          "heading": "4. Запрещённые действия",
          "body": "Мошенничество, злоупотребление автоматизацией, вмешательство в чужой аккаунт и незаконная деятельность запрещены."
        },
        {
          "heading": "5. Изменение сервиса",
          "body": "Функции, каталог игр и интерфейс могут изменяться или временно приостанавливаться."
        },
        {
          "heading": "6. Связь",
          "body": "Для споров и вопросов используйте Живую поддержку. Официальный юридический адрес будет опубликован после подтверждения."
        }
      ]
    },
    "privacy": {
      "title": "Политика конфиденциальности",
      "summary": "Сбор, хранение и использование персональных данных.",
      "sections": [
        {
          "heading": "1. Какие данные",
          "body": "Могут обрабатываться данные аккаунта и контактов, метаданные платежей, технические журналы и переписка поддержки."
        },
        {
          "heading": "2. Цель",
          "body": "Данные используются для управления аккаунтом, безопасности, платежей, поддержки и законных обязательств."
        },
        {
          "heading": "3. Передача",
          "body": "Данные не продаются. Могут передаваться платёжным провайдерам, игровым агрегаторам и органам по закону."
        },
        {
          "heading": "4. Срок хранения",
          "body": "Данные хранятся столько, сколько нужно для сервиса и закона, затем удаляются или обезличиваются."
        },
        {
          "heading": "5. Ваши права",
          "body": "Через поддержку можно запросить доступ, исправление или удаление с учётом законных исключений."
        },
        {
          "heading": "6. Безопасность",
          "body": "Применяются технические и организационные меры; абсолютной защиты не существует."
        }
      ]
    },
    "bonuses": {
      "title": "Правила бонусов",
      "summary": "Бонусы, промокоды и условия колеса удачи.",
      "sections": [
        {
          "heading": "1. Общее",
          "body": "Бонусы, промокоды и награды колеса зависят от условий кампании и статуса аккаунта."
        },
        {
          "heading": "2. Реальный и бонусный баланс",
          "body": "Средства учитываются раздельно. Бонусная игра доступна только в разрешённых играх."
        },
        {
          "heading": "3. Отыгрыш",
          "body": "Требования отыгрыша указываются в кампании. При невыполнении бонус может быть отменён."
        },
        {
          "heading": "4. Злоупотребления",
          "body": "Мультиаккаунты и обход условий могут привести к отмене бонусов и ограничениям."
        },
        {
          "heading": "5. Изменения",
          "body": "Кампании могут приостанавливаться или меняться. Переходные правила сообщаются в тексте кампании или через поддержку."
        }
      ]
    },
    "payments": {
      "title": "Депозит и вывод",
      "summary": "Способы оплаты, лимиты и проверка.",
      "sections": [
        {
          "heading": "1. Депозит",
          "body": "Депозит принимается только активными способами. Неверная сеть, реквизиты или сумма могут задержать или потерять средства."
        },
        {
          "heading": "2. Вывод",
          "body": "Заявки могут проверяться. Может потребоваться тот же способ и/или KYC. Лимиты зависят от способа и статуса."
        },
        {
          "heading": "3. Валюта",
          "body": "Основная валюта — указанная на платформе. Конвертация и комиссии зависят от способа."
        },
        {
          "heading": "4. Чеки и проверка",
          "body": "Некоторые способы требуют чек или доп. подтверждение. Поддельные документы запрещены."
        },
        {
          "heading": "5. Возвраты",
          "body": "Ошибочные или дублирующие операции разбираются с поддержкой и партнёрами по фактам."
        }
      ]
    },
    "responsible": {
      "title": "Ответственная игра",
      "summary": "Самоограничения и предотвращение вредного поведения.",
      "sections": [
        {
          "heading": "1. Принцип",
          "body": "Игра — развлечение. Выигрыш не гарантирован. Не играйте на средства, которые не можете позволить себе потерять."
        },
        {
          "heading": "2. Инструменты",
          "body": "Охлаждение, самоисключение и закрытие аккаунта могут быть доступны в профиле/безопасности или через поддержку."
        },
        {
          "heading": "3. Помощь",
          "body": "При риске игровой зависимости обратитесь за профессиональной помощью и ограничьте аккаунт."
        },
        {
          "heading": "4. Несовершеннолетние",
          "body": "Участие несовершеннолетних запрещено. Такие аккаунты закрываются."
        }
      ]
    },
    "kyc": {
      "title": "Подтверждение аккаунта (KYC)",
      "summary": "Проверка личности и контактов.",
      "sections": [
        {
          "heading": "1. Когда",
          "body": "KYC может потребоваться при выводе, крупных суммах, рисках или по закону."
        },
        {
          "heading": "2. Документы",
          "body": "Могут потребоваться удостоверение личности, подтверждение адреса и способа оплаты. Список уточняет поддержка."
        },
        {
          "heading": "3. Обработка",
          "body": "Данные обрабатываются только для проверки и хранятся по политике конфиденциальности."
        },
        {
          "heading": "4. Результат",
          "body": "До завершения проверки операции могут быть ограничены. Несоответствие может привести к закрытию аккаунта."
        }
      ]
    },
    "aml": {
      "title": "AML и борьба с мошенничеством",
      "summary": "Предотвращение подозрительных операций.",
      "sections": [
        {
          "heading": "1. Цель",
          "body": "Платформа стремится предотвращать отмывание средств, мошенничество и нарушения санкций."
        },
        {
          "heading": "2. Мониторинг",
          "body": "Операции, входы и поведение аккаунта могут проверяться автоматически и/или вручную."
        },
        {
          "heading": "3. Меры",
          "body": "При подозрениях депозит/вывод могут быть приостановлены, аккаунт заморожен, а при необходимости уведомлены органы."
        },
        {
          "heading": "4. Сотрудничество",
          "body": "Пользователи должны своевременно отвечать на запросы поддержки."
        }
      ]
    },
    "fairplay": {
      "title": "Честная игра и возраст",
      "summary": "Справедливость игр, правила провайдеров и возрастные ограничения.",
      "sections": [
        {
          "heading": "1. Провайдеры",
          "body": "Игры могут предоставляться сторонними провайдерами. Действуют их правила и механизмы RNG/честности."
        },
        {
          "heading": "2. Результаты",
          "body": "Итоги определяются системой провайдера. При технических сбоях сессия может быть пересмотрена."
        },
        {
          "heading": "3. Возраст",
          "body": "Игра на реальные деньги только для лиц законного возраста. Может потребоваться подтверждение возраста."
        },
        {
          "heading": "4. Язык",
          "body": "Интерфейс провайдера показывается только на поддерживаемых языках. Если выбранный язык не поддерживается, используется запасной язык провайдера."
        }
      ]
    },
    "self_exclusion": {
      "title": "Политика самоограничения",
      "summary": "Охлаждение, самоисключение и временное или постоянное ограничение аккаунта.",
      "sections": [
        {
          "heading": "1. Цель",
          "body": "Политика даёт инструменты для паузы или ограничения игровой активности в интересах ответственного использования."
        },
        {
          "heading": "2. Инструменты",
          "body": "Охлаждение, самоисключение и закрытие аккаунта могут быть доступны в профиле/безопасности или через Живую поддержку в зависимости от конфигурации."
        },
        {
          "heading": "3. Действие",
          "body": "При активном самоограничении депозит, игра или другие выбранные операции могут быть ограничены. Досрочное снятие обычно недоступно."
        },
        {
          "heading": "4. Процесс запроса",
          "body": "Обращения через поддержку проверяются. Может потребоваться подтверждение личности. Срок зависит от типа запроса."
        },
        {
          "heading": "5. Ответственность",
          "body": "Инструменты снижают риск, но не заменяют профессиональную помощь."
        },
        {
          "heading": "6. Юридическая оговорка",
          "body": "Реквизиты компании и применимое право будут добавлены после подтверждения владельцем. Текст является черновиком."
        }
      ]
    },
    "disputes": {
      "title": "Политика разрешения споров",
      "summary": "Порядок рассмотрения споров по платежам, бонусам, результатам игр и аккаунту.",
      "sections": [
        {
          "heading": "1. Область",
          "body": "Политика касается депозитов/выводов, бонусов, статуса аккаунта и игровых сессий."
        },
        {
          "heading": "2. Первое обращение",
          "body": "Сначала сообщите о споре в Живую поддержку. Укажите номер заявки, дату, сумму и доказательства по возможности."
        },
        {
          "heading": "3. Проверка",
          "body": "Поддержка может проверить журналы, платёжные метаданные и данные провайдера. Результаты игр могут определяться системой стороннего провайдера."
        },
        {
          "heading": "4. Сроки",
          "body": "Простые случаи обычно рассматриваются быстрее; сложные проверки занимают больше времени. Точный SLA будет опубликован после подтверждения."
        },
        {
          "heading": "5. Результат",
          "body": "Решение принимается по фактам. Возможны корректировка, возврат или разъяснение. Поддельные документы могут привести к ограничениям."
        },
        {
          "heading": "6. Эскалация",
          "body": "Дальнейшие пути эскалации и официальный юридический адрес будут добавлены после подтверждения. Текст является черновиком."
        }
      ]
    }
  }
}
